import PouchDB from 'pouchdb';
import PouchdbFind from 'pouchdb-find';


export default class DB {

    constructor(){
        PouchDB.plugin(PouchdbFind);
        this.db = new PouchDB('famas-doc');

        this.dbEmployee = new PouchDB('employee-doc');

        this.dbForProcessing = new PouchDB('processing-doc');

        //processing
        this.dbForProcessing.createIndex({
            index: {
              fields: ['assetTag']
            }
        });

        //employee
        this.dbEmployee.createIndex({
            index: {
              fields: ['idMaster']
            }
        });

        this.db.createIndex({
            index: {
              fields: ['assetDesc']
            }
        });

        this.db.createIndex({
            index: {
              fields: ['serialNo']
            }
        });

        this.db.createIndex({
            index: {
              fields: ['assetTag']
            }
        });

        this.db.createIndex({
            index: {
              fields: ['headerIdMaster']
            }
        });

        this.db.createIndex({
            index: {
              fields: ['lineIdMaster']
            }
        });

    }

    //Processing
    getAllForProcessing = async()=>{
        let allForProcessing = await this.dbForProcessing.allDocs({ include_docs: true });
        let processing = {};
        allForProcessing.rows.forEach(n => processing[n.id] = n.doc);
        return processing;
    }

    createForProcessing  = async(famasItem)=>{
        const res = await this.dbForProcessing.post(famasItem);
        return res;
    }

    deletForProcessing = async(emp)=>{
        const res = await this.dbForProcessing.remove(emp);
        return res;
    }

    searchForProcessingByAssetTag(p_textToSearch){
        return this.dbForProcessing.find({
            selector: {
            assetTag: p_textToSearch
            }
        });
    }

    //TMs
    createTm  = async(profile)=>{
        profile.createdAt = new Date();
        profile.updatedAt = new Date();
        const res = await this.dbEmployee.post(profile);
        return res;
    }

    searchTmByIdMaster(p_textToSearch){
        return this.dbEmployee.find({
            selector: {
            idMaster: p_textToSearch
            }
        });
    }

    getAllTms = async()=>{
        let allTms = await this.dbEmployee.allDocs({ include_docs: true });
        let famas = {};
        allTms.rows.forEach(n => famas[n.id] = n.doc);
        return famas;
    }
    
    //
    searchByAssetTag(p_textToSearch){
        return this.db.find({
            selector: {
            assetTag: p_textToSearch
            }
        });
    }

    searchByLineIdMaster(p_textToSearch){
        return this.db.find({
            selector: {
            lineIdMaster: p_textToSearch
            }
        });
    }

    searchByHeaderIdMaster(p_textToSearch){
        return this.db.find({
            selector: {
                headerIdMaster: p_textToSearch
            }
        });
    }

    searchByAssetDescription(p_textToSearch){
        return this.db.find({
            selector: {
            assetDescription: p_textToSearch
            }
        });
    }   

    searchByAssetDescriptionLike(p_textToSearch){
        return this.db.find({
            selector: {
            assetDescription: {"$regex": p_textToSearch}
            }
        });
    }   

    getAllFamas = async()=>{
        let allFamas = await this.db.allDocs({ include_docs: true });
        let famas = {};
        allFamas.rows.forEach(n => famas[n.id] = n.doc);
        return famas;
    }

    createFamasFromDbItem = async(famas)=>{
        const res = await this.db.post(famas);
        return res;
    }

    createFamas  = async(famas)=>{
        console.log("CAPTURE FAMAS", famas);
        famas.createdAt = new Date();
        famas.updatedAt = new Date();
        const res = await this.db.post(famas);
        return res;
    }

    updateFamas = async(famas) => {
        famas.updatedAt = new Date();
        famas.updateInfo = "Test update mode"
        const res = await this.db.put({...famas});
        return res;
    }

    //EMPS
    createEmpFromDbItem = async(emp)=>{
        const res = await this.dbEmployee.post(emp);
        return res;
    }

}